import { Spinner } from "baseui/spinner";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "100%",
        alignItems: "center",
      }}
    >
      <Spinner />
    </div>
  );
};

export default Loader;
